import { MButton } from '@assets/mui/@material-extend';
import { useBitrix } from '@context/useBitrixUser/useBitrix';
import Typography from '@mui/material/Typography';
import { companyProfileService } from '@services/requests/companyProfileService';
import { AccessData } from '@services/requests/companyProfileService/types/accessData';
import React, { useEffect, useState } from 'react';

import { PasswordModule } from '../../CompanyProfileModules/PasswordModule';
import { AccessTabSkeleton } from './AccessTabSkeleton';
import { AccessTabStyledContainer } from './StyledComponents';

function AccessTab() {
  const [accessData, setAccessData] = useState<AccessData | null>(null);
  const [isDataLoading, setIsDataLoading] = useState<boolean>(true);
  const [errors, setErrors] = useState<string[]>([]);

  const { useBitrixUser } = useBitrix();
  const [{ bitrixUser, isUserLoading }] = useBitrixUser().useState();

  useEffect(() => {
    if (!bitrixUser && !isUserLoading) {
      setIsDataLoading(false);
    }
    if (!bitrixUser || isUserLoading) {
      return;
    }
    const fetchData = async () => {
      const result = await companyProfileService().LoadAccessData(bitrixUser.id);
      if ('errors' in result) {
        setIsDataLoading(false);
        setErrors(result.errors);
        return;
      }

      setIsDataLoading(false);
      setAccessData(result);
    };
    fetchData();
  }, [bitrixUser, isUserLoading]);

  if (errors.length > 0) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {errors.map((error, index) => (
          <div key={'error-' + index}>
            <span className="company-status error">{error}</span>
          </div>
        ))}
      </div>
    );
  }

  if (isDataLoading) {
    return <AccessTabSkeleton />;
  }

  if (!accessData) {
    return null;
  }

  return (
    <AccessTabStyledContainer>
      <div className="main-tab-column">
        <PasswordModule accessData={accessData} />
        <div>
          <MButton
            className={'main-tab-button'}
            variant={'contained'}
            color={'secondary'}
            form="password-form"
            type="submit"
          >
            <Typography color={'white'} fontSize={16} fontWeight={600}>
              {accessData.messages.btn_save}
            </Typography>
          </MButton>
        </div>
      </div>
    </AccessTabStyledContainer>
  );
}

export { AccessTab };
